<app-section-header surtitle="Restaurant" title="Le Restaurant"></app-section-header>

<div class="content-container">
    <mat-card class="info-card ambiance">
        <mat-card-content>
            <h3 class="section-title">Ambiance de la Guinguette</h3>
            <p>Restauration simple et efficace: vous êtes dans une guinguette !!</p>
            <p>Pas de chichi, ambiance détente, on se prélasse à l'ombre du châtaignier.</p>
            <p>Nous travaillons selon les disponibilités du moment avec des produits frais du coin.</p>
        </mat-card-content>
    </mat-card>

    <mat-card class="info-card photo">
        <mat-card-content>
            <h3 class="section-title">Photos de Manjocarn</h3>
            <div class="photo-gallery">
                <ng-container *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]; let idx = index">
                    <div class="photo-container" appScrollReveal [revealDelay]="(idx % 8) * 50" (click)="openFullscreen($event)">
                        <img [src]="'../assets/photo/' + i + '.jpg'" [alt]="'Photo de Manjocarn ' + i" loading="lazy">
                    </div>
                </ng-container>
            </div>
        </mat-card-content>
    </mat-card>

    <div class="fullscreen-overlay" (click)="closeFullscreen()">
        <img src="" alt="Photo agrandie">
        <button class="close-button" aria-label="Fermer la photo">&times;</button>
    </div>
</div>
